<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-row dense>
          <v-col cols="12" sm="12" md="2">
            <v-btn color="#eb4034" dark rounded :to="{ name: 'Veiculos' }">Ver todos os veiculos</v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="8">
        <Carousel :veiculo="veiculo.descricao.toLowerCase().replace(/\s/g, '')"/>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <Form />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "VeiculoDetalhes",

  components: {
    Form: () => import("@/components/Form"),
    Carousel: () => import("@/components/Carousel")
  },

  computed: {
    ...mapGetters("veiculo", { veiculo: "getSelectedVeiculo" }),
    ...mapGetters("vendedor", ["getVendedor"])
  },

  methods: {
    init() {
      if (!this.getVendedor) {
        this.$router.push({ name: "400" });
      } else if (!this.veiculo && this.getVendedor) {
        this.$router.push(`/${this.getVendedor}`);
      }
    }
  },

  mounted() {
    this.init();
  }
};
</script>
